import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/exerciseForm';

/**
 * 課題提出フォーム画面のState型
 */
export interface IExerciseFormState {
	readonly reportName: string;
	readonly reportTemplateFileName: string;
	readonly submittedReportFile: string;
	readonly resultStatus: number;
	readonly displayDownloadButton: boolean;
	readonly displayUploadButton: boolean;
	readonly displaySubmittedReportDownloadButton: boolean;
	readonly displayDeleteButton: boolean;
}

/**
 * 課題提出フォーム画面のState初期値
 */
const initialState: IExerciseFormState = {
	displayDeleteButton: false,
	displayDownloadButton: false,
	displaySubmittedReportDownloadButton: false,
	displayUploadButton: false,
	reportName: '',
	reportTemplateFileName: '',
	resultStatus: 0,
	submittedReportFile: '',
};

/**
 * 課題提出フォーム画面用reducer
 * @param state State
 * @param action アクション
 */
const exercise = (state = initialState, action: Action) => {
	if (isType(action, Actions.setExerciseFormParams)) {
		return {
			...state,
			displayDeleteButton: action.payload.displayDeleteButton,
			displayDownloadButton: action.payload.displayDownloadButton,
			displaySubmittedReportDownloadButton:
				action.payload.displaySubmittedReportDownloadButton,
			displayUploadButton: action.payload.displayUploadButton,
			reportName: action.payload.reportName,
			reportTemplateFileName: action.payload.reportTemplateFileName,
			resultStatus: action.payload.resultStatus,
			submittedReportFile: action.payload.submittedReportFile,
		};
	}

	if (isType(action, Actions.clearExerciseFormParams)) {
		return initialState;
	}

	return state;
};

export default exercise;



// WEBPACK FOOTER //
// ./src/reducers/exerciseForm.ts